import { LstAuthModuleOptions } from '@savvaslearning/lst-auth';
import { environment } from '../../../environments/environment';
import { AssessmentReportingType } from '../../multi-stage-growth-report/models/multi-stage-growth-report.model';
import { Locale } from './common.model';

export enum CommandAction {
  NAVIGATE_TO_ERROR = 'NAVIGATE_TO_ERROR',
}
// Add command action here for the modal

export enum GrowthReportStoreNames {
  GROWTH_REPORT = 'growthReport',
  SHARED = 'shared',
}

export const DEFAULT_LOCALE = Locale.EN;
export const OVERLAY_SPINNER_ID = 'overlay-spinner-id';

export const EMPTY_STRING = '';

export enum IconDetails {
  // COLORS
  COLOR_GRAYDARKER = 'gray-darker',

  // ICON NAMES
  NAME_INFORMATION_CIRCLE = 'information-circle',
  NAME_PRINT = 'print',

  // ICON IDS
  END_TO_END_ID = 'cel-help-icon-button',
  STUDENT_PRINT_ID = 'student-print-popup-menu',

  // ALIGNMENTS
  ALIGNMENT_LEFT = 'left',

  // SIZES
  SIZE_REGULAR = 'regular',
}

export const AssessmentReportingTypes = [
  AssessmentReportingType.BOY,
  AssessmentReportingType.MOY,
  AssessmentReportingType.EOY,
];

export const DEFAULT_GRAPH_WIDTH = 700;
export const IPAD_GRAPH_WIDTH = 600;

export const LST_MODULE_OPTIONS: LstAuthModuleOptions = {
  appId: environment.appId,
  authGatewayBaseUrl: environment.authGatewayUrl,
  authContextId: environment.authContextId,
  authGatewayClientId: environment.rbsConfig.clientId,
  rbsTokenScope: environment.rbsConfig.scope,
  ssoBaseUrl: environment.ssoUrl,
  rbsTokenGrantType: environment.rbsConfig.grant_type,
  loginQueryParams: environment.ssoLoginQueryParams,
  errorRoute: environment.errorRoute,
  authCallbackRoute: environment.authCallbackRoute,
};

export const REALIZE_FMS_ATTRIBUTES = 'realize.fmsAttributes';
export const FLAG_VALUE_ON = 'ON';
export const FLAG_VALUE_OFF = 'OFF';

export enum FMS_FLAG {
  ENABLE_VIEW_ASSIGN_RESOURCE_PATH_BASED = 'enable-view-assign-resource-path-based',
  ENABLE_GROWTH_REPORT_PRINT_ALL_STUDENTS_FUNCTIONALITY = 'enable.growth.report.print.all.students',
}
